import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/config';
import { PHONE_TABS, QUICK_ADD, TAP } from '../utils/layoutMode';
// ⚠ THE SHEETS USED TO CLOSE ONLY BY TAPPING OUTSIDE. On a 390px phone with a
// tall sheet that is a few dozen pixels of screen, and missing it re-opens
// whatever is underneath. BottomSheet adds swipe-down, the back gesture, and a
// visible drag handle.
import BottomSheet, { sheetRow } from './BottomSheet';

// ── FIELD MODE'S BOTTOM BAR ─────────────────────────────────────────────────
//
//   Today · Jobs · ➕ · Schedule · More
//
// ⚠ THE OWNER'S FIVE, AND THE MIDDLE ONE IS AN ACTION rather than a place.
// Leads, Storm and Dashboard moved into More — they are READING screens, and a
// phone in a driveway is for DOING. Today is first and is the home, because
// opening the app on site should answer "what am I doing now" before it asks
// anything.
//
// ⚠ EVERY TARGET IS AT LEAST 44px AND NOTHING IS BEHIND A HOVER. A phone has
// no hover, and a 36px target in a work glove is a target you miss.
//
// ⚠ AND IT SITS ABOVE THE HOME INDICATOR. env(safe-area-inset-bottom) or the
// last tab is under the iPhone's gesture bar, which is a tap that scrolls the
// app away instead.
export default function FieldNav({ more = [], unread = 0 }) {
  const [sheet, setSheet] = useState('');   // '' | 'add' | 'more'
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = p => location.pathname === p || location.pathname.startsWith(`${p}/`);
  const moreActive = more.some(m => isActive(m.path));

  function go(path) {
    setSheet('');
    navigate(path);
  }

  async function out() {
    setSheet('');
    await signOut(auth);
    navigate('/login', { replace: true });
  }

  const bar = {
    position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 2000,
    display: 'flex', alignItems: 'stretch',
    background: '#151728', borderTop: '1px solid rgba(255,255,255,0.10)',
    paddingBottom: 'env(safe-area-inset-bottom, 0px)',
  };
  const tab = active => ({
    flex: 1, minHeight: TAP + 10, display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', gap: 2,
    background: 'none', border: 'none', cursor: 'pointer', font: 'inherit',
    color: active ? '#e91e8c' : 'rgba(255,255,255,0.62)',
    fontSize: 10.5, fontWeight: 700, padding: '6px 2px', position: 'relative',
  });


  return (
    <>
      <nav style={bar} aria-label="Field Mode">
        {PHONE_TABS.map(t => {
          if (t.action) {
            const open = sheet === t.action;
            const add = t.action === 'add';
            return (
              <button key={t.action} type="button" style={tab(open || (t.action === 'more' && moreActive))}
                onClick={() => setSheet(s => (s === t.action ? '' : t.action))}
                aria-label={t.label} aria-expanded={open}>
                <span style={add ? {
                  fontSize: 15, width: 34, height: 34, borderRadius: 17, background: '#e91e8c',
                  color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: -2,
                } : { fontSize: 19 }}>{t.icon}</span>
                <span>{t.label}</span>
                {t.action === 'more' && unread > 0 && (
                  <span style={{ position: 'absolute', top: 4, right: '50%', marginRight: -20, background: '#e74c3c', color: '#fff', fontSize: 10, fontWeight: 800, borderRadius: 9, padding: '1px 5px' }}>{unread}</span>
                )}
              </button>
            );
          }
          return (
            <button key={t.path} type="button" style={tab(isActive(t.path))} onClick={() => go(t.path)} aria-label={t.label}>
              <span style={{ fontSize: 19 }}>{t.icon}</span>
              <span>{t.label}</span>
            </button>
          );
        })}
      </nav>

      {/* ⚠ SWIPE DOWN, TAP OUTSIDE, OR THE BACK GESTURE — and a visible drag
          handle so the swipe is discoverable at all. It used to close ONLY by
          tapping the thin strip of screen around it. See BottomSheet. */}
      <BottomSheet
        open={!!sheet}
        onClose={() => setSheet('')}
        title={sheet === 'add' ? 'Start something' : 'More'}
      >
        {(sheet === 'add' ? QUICK_ADD : more).map(item => (
          <button key={item.path} type="button" style={sheetRow(isActive(item.path))} onClick={() => go(item.path)}>
            <span style={{ fontSize: 19, width: 24, textAlign: 'center' }}>{item.icon}</span>
            <span>{item.label}</span>
          </button>
        ))}
        {sheet === 'more' && (
          <button type="button" style={{ ...sheetRow(false), color: '#e74c3c' }} onClick={out}>
            <span style={{ fontSize: 19, width: 24, textAlign: 'center' }}>🚪</span>
            <span>Sign out</span>
          </button>
        )}
      </BottomSheet>
    </>
  );
}
